import areObjsEqualByKey from '@glass/shared/helpers/utils/areObjsEqualByKey';

const isContentWordEqual = (a, b) => areObjsEqualByKey(['singular'], a, b);

export default isContentWordEqual;
